module.exports = __webpack_public_path__ + "media/images/male-68f59bc1a9dc09dac3e3c85acf07a629.jpg";